export default "__VITE_ASSET__KVxOlp5N__"